/* eslint-disable @typescript-eslint/naming-convention */
import React from "react";
import PropTypes from "prop-types";
import Select, { ActionMeta, Props } from "react-select";
import CustomSelectProps, { IOption } from "./Select.types";
import * as S from "./Select.styles";

/**
 * BW Select component.
 */
const BWSelect = React.forwardRef<never, Props & CustomSelectProps>((props, ref) => {
    const { onValueChange, fontSize, width, height, variant, error, ...rest } = props;

    const [enterPressed, setEnterPressed] = React.useState<boolean>(false);

    const onKeyDown = (e: React.KeyboardEvent): void => {
        if (e.key === "Enter") setEnterPressed(!enterPressed);
    };

    const internalOnChange = (newValue: unknown, actionMeta: ActionMeta<unknown>) => {
        const option = newValue as IOption;
        if (onValueChange) {
            onValueChange(option, actionMeta);
        }
    };

    return (
        <S.SelectWrapper fontSize={fontSize} width={width} height={height} variant={variant} error={error}>
            <Select
                classNamePrefix="bw-react-select"
                ref={ref}
                components={{ IndicatorSeparator: () => null }}
                onKeyDown={(e: React.KeyboardEvent<Element>) => onKeyDown(e)}
                menuIsOpen={enterPressed || undefined}
                onChange={internalOnChange}
                {...rest}
            />
        </S.SelectWrapper>
    );
});

BWSelect.defaultProps = {
    height: 30,
    fontSize: 14,
    isSearchable: false
};

BWSelect.propTypes = {
    fontSize: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    error: PropTypes.bool
};

BWSelect.displayName = "Select";

export default BWSelect;
